// src/constants.ts
var ADDON_ID = "storybook/links";
var PARAM_KEY = `links`;
var constants_default = {
  NAVIGATE: `${ADDON_ID}/navigate`,
  REQUEST: `${ADDON_ID}/request`,
  RECEIVE: `${ADDON_ID}/receive`
};

export { ADDON_ID, PARAM_KEY, constants_default };
